import { useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import { env } from "../../constants/env";
import classes from "./DownloadReportPage.module.css";
import CommonButton from "../ui/CommonButton/CommonButton";

const DownloadCertificationReportPage = () => {
  const { labId } = useParams();
  const { token } = useAuth();

  const downloadReport = async () => {
    try {
      const response = await fetch(
        `${env.kataApiUrl}/api/certification/${labId}/download-report`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) throw new Error("Failed to download report");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Certification_Report_${labId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      toast.error(err.message || "Download failed");
    }
  };

  return (
    <div className={`${classes.wrapper} py-0`}>
      <h2>Download Certification Report</h2>
      <div className="d-flex justify-content-center mt-4">
        <CommonButton title={<span>Download Report</span>} onClick={downloadReport} />
      </div>
    </div>
  );
};

export default DownloadCertificationReportPage;